<template>
    <div>
        <div class="label-input mb-2">
            {{ $t('dashboard.create.languageFilter.label') }}
        </div>

        <RedesignRadioGroup
            v-model="model"
        >
            <RedesignRadio
                data-testid="template-language-current"
                :label="String($t('dashboard.create.languageFilter.currentLanguage'))"
                :data-value="activeLanguage.LanguageID"
                :border="bordered"
            />
            <RedesignRadio
                data-testid="template-language-all"
                :label="String($t('dashboard.create.languageFilter.all'))"
                :data-value="LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE"
                :border="bordered"
            />
        </RedesignRadioGroup>
    </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import { activeLanguage } from '@/composables/globalData/useLanguages'
import { LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE } from '@/enum/default-layout-config'
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import RedesignRadio from '@/components/RedesignBaseComponents/Inputs/RedesignRadio.vue'

/* Props */
const props = defineProps<{
    value: number
    bordered?: boolean
}>()

/* Emit */
const emit = defineEmits<{
    (e: 'input', payload: number): void
    (e: 'update:value', payload: number): void
}>()

/* Composable */
const model = useVModel(props, 'value', emit, { eventName: 'input' })
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
    @apply flex;
}
</style>
